<script>
import FoodAddPelletRecord from '@/layerAdmin/components/FoodAddPelletRecord.vue';
import PelletFoodStockBalancesTable from '@/layerAdmin/components/PelletFoodStockBalancesTable.vue';

export default {
  components: {
    FoodAddPelletRecord,
    PelletFoodStockBalancesTable,
  },

  data: () => ({
    addPelletFoodVisible: false,

    reloadStockTrigger: 0,
  }),

  methods: {
    onRecordAdded(feedRecord) {
      this.reloadStockTrigger++;
    },
  },
}
</script>

<template>
  <div>

    <div class="row">
      <div class="col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-3" ref="addCardElem">
        <b-card>
          <food-add-pellet-record
            v-if="addPelletFoodVisible"
            @added="onRecordAdded"
            @cancel="addPelletFoodVisible=false" />

          <button v-else type="button" class="btn btn-outline-primary btn-block" @click="addPelletFoodVisible=true">Add Pellet Food</button>
        </b-card>
      </div>
    </div>

    <b-card class="mt-2" no-body>
      <b-tabs card>
        <b-tab title="Pellet Food">
          <pellet-food-stock-balances-table :trigger-reload="reloadStockTrigger" />
        </b-tab>
      </b-tabs>
    </b-card>

  </div>
</template>



// WEBPACK FOOTER //
// src/layerAdmin/views/AdminFoodView.vue